import React from "react";
import styled from "styled-components";
import IUMRSNavBar from "./IUMRSNavbar.jsx";
import { ICAMNavroute } from '../../../utils/ICAMnavroute.js';
import IUMRSFooter from "./IUMRSFooter";
import { useDesktopSiteDetection } from "../../../hooks/mobile_desktop_mode.jsx";
import NotificationDropdown from "../../../hooks/notificationsDropdown.jsx";

const IUMRSAbstract = () => {

    const isDesktopSiteOnMobile = useDesktopSiteDetection()
    return (
        <Wrapper>
            <IUMRSNavBar navroute={ICAMNavroute} />
            <NotificationDropdown />
            <Container className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>
                <div className="header">
                    <h2>ABSTRACT SUBMISSION</h2>
                </div>
                <div className="summary-section">
                    <div className="intro-text">
                        <span><i>Authors note</i></span>
                    </div>

                    <div className="main-text">
                        <p> <span className="heading">Submission Details</span><br /> </p>
                        <p>During the conference registration process, attendees have the option to submit an abstract for consideration
                            in a select symposium. If an attendee wishes to submit an additional abstract, they may submit one further
                            abstract for review to the AMRS Ghana email.


                            <span style={{color: "red"}}> The LOC has decided to give another extension for the submission of abstracts up until: 31st October 2025 (23:59, GMT). There will be no further extensions</span>, later abstracts will not be accepted.
                        Acceptance letters are being sent out on a rolling basis. If you experience a delay in receiving a response, please feel free to contact us via email.</p>
                    <p> <span className="heading">Abstract Structure</span></p>
                    <p>
                        A one page abstract (150-300 words) should be prepared on A4 or Letter (8 1/2&quot; x 11&quot;) size pages with 1&quot; (24 mm)
                        margins. All text including title and figures (if any) should fit within these margins. Use 12 point Times New Roman
                        single-spaced type for the main body of the text, 14 point for the title. Your abstract should include the title, list of
                        authors, affiliations with addresses, the text, keywords and email for the speaker (and corresponding author if different)
                        in that order.
                    </p>
                    <p>
                        The name of the presenter should be underlined. We will assume you prefer an oral presentation unless
                        you specifically request a poster presentation during your registration process. Please select the
                        possible Symposium or Theme your abstract is being submitted for when uploading your abstract file(preferred) or otherwise list it at the bottom of your
                        abstract (on a separate line) to help us best place your presentation in the program.
                    </p>
                    <p>
                       We prefer that you prepare your abstract in Microsoft Word format but PDF files are also acceptable. Upload your abstract during your registration <a href="/iumrs-icam25/registration">here</a>
                            , Keeping it within a 1Mb file size limit. If for any reason you are unable to upload and submit your abstract during the registartion process, you can send it 
                            seperately as an attachment in an email addressed to: <a href="mailto:amrsghana@gmail.com">amrsghana@gmail.com</a><br/>
                            <br/>
                            Any further inquiry can be made using any of the contact information below. Thank you.

                    </p>
                </div>
            </div>
        </Container><IUMRSFooter />
        </Wrapper>
    )
}

const Wrapper =styled.div`
`

const Container = styled.div`  
     font-family: "Noto Serif", serif;
     font-weight: 300;

    .header{
        width: 100%;
        height: 10rem;
        background-color: #082D4A;
        margin: 0;
        text-align: center;
        
        
        h2{
            margin: 0;
            color: white;
            font-family: "PT Serif", serif;
            font-style: normal;
            font-weight: 600;
            letter-spacing: .005em;
            font-size: 1.5rem;
            line-height: 10rem;
            
        }
    }

    .summary-section{
        margin: 2em 2em 1em 2em;

        p{
            color:  rgb(97, 96, 96);
            line-height: 1.8em;
            font-size: 1.1em;
        }

        .main-text{text-align: justify;}
    }
    .intro-text {
        width: 100%;
        display: flex;
        justify-content: center;
        text-align: center;
        margin-bottom: 1.5rem;

        span{
            color:  #082D4A;
            font-weight: 600;
            font-size: 1.7rem;
        }
        
        
        p {
            max-width: 90%;
            
            
        }
    }

    .heading {
        color: #082D4A;
        font-size: 1.3rem;
        font-weight: 500;
        margin-bottom: 2em;
    }

    @media only screen and (min-width: 800px) {
        .header{
            h2{font-size: 2rem;}
        }
        .summary-section{
            margin: 5em 3em 1em 3em;

            .intro-text {margin-top: 3rem;}
        }
    }

    @media only screen and (min-width: 1000px) {
        .title{
            h2{
                font-size: 2.9em;
            }
        }
        .summary-section{
            width: 56em;
            margin: 0 auto;
        }
    }

    &.desktop-site-mode {
        
        .summary-section {
            margin: 3em;
            
            p {
                font-size: 0.65em;
                line-height: 1.5em;
            }
        }
        
        .intro-text span {
            font-size: 2em;
        }
        
        .heading {
            font-size: 0.9em;
        }
    }
    
`



export default IUMRSAbstract;